import { trpc, TRPCReactQueryOptions, TRPCRouterInputs, TRPCRouterOutputs } from '@sternum/web/services/trpc';

const emptyData: TRPCRouterOutputs['systemClient']['getFavoriteClients'] = [];

export function useFavouriteClients(
  request: TRPCRouterInputs['systemClient']['getFavoriteClients'],
  options?: TRPCReactQueryOptions['systemClient']['getFavoriteClients'],
) {
  const { data, ...rest } = trpc.systemClient.getFavoriteClients.useQuery(request, options);

  return {
    clients: data || emptyData,
    ...rest,
  };
}
